import {PIXI} from '@colonist/pixi'
import {GameColor} from '../GameColor'
import {GameFont} from '../GameFont'
import {uiGameManager} from '../../../shared/scripts/EntryShared'
import {TranslationObject} from '@colonist/i18n'
import {clientI18n} from '../ClientI18n'
import {UIGameResponsiveController} from '../ui_game/UIGameResponsiveController'
import {ToolTipText} from 'code/client/web/scripts/ui_game/ui_game_tooltip/UIWGameToolTipController'

export class TextView extends PIXI.Text {
    initialX: number
    initialY: number
    initialW: number
    initialH: number

    /**
     * @deprecated Use {@link setText} instead
     */
    set text(text: string) {
        super.text = text
    }

    /**
     * @deprecated Use {@link changeStyle} instead
     */
    set style(style: any) {
        super.style = style
    }

    private clickAction: (event) => void

    constructor(text: TranslationObject, x: number, y: number, w: number, h: number, container: PIXI.Container, fontSize: number = GameFont.Size.Normal, color: string = GameColor.getColor(GameColor.Color.Gray0), centerY: boolean = true, style?: Partial<PIXI.TextStyle>, cache: boolean = true) {
        const baseStyles: Partial<PIXI.TextStyle> = {
            fontFamily: 'Open Sans',
            fontSize: GameFont.getResponsiveSize(fontSize),
            fill: color,
            wordWrap: true,
            wordWrapWidth: w,
            align: 'center',
            breakWords: true,
        }

        super(clientI18n.t(text.key, text.options), {...baseStyles, ...style})
        this.resolution = 2 * UIGameResponsiveController.resolutionScale
        this.roundPixels = true
        this.initialX = x
        this.initialY = y
        this.initialW = w
        this.initialH = h

        this.x = x
        this.repositionY(centerY)

        this.clickAction = (event) => undefined
        this.initClick()

        if(cache) this.cacheAsBitmap = true

        container.addChild(this)
    }

    setText(text: TranslationObject, cache: boolean = true) {
        const translatedText = clientI18n.t(text.key, text.options)
        if(super.text == translatedText) return
        this.resetCache(() => super.text = translatedText, cache)
    }

    getText(): string {
        return super.text
    }

    hide() {
        if(this.parent == undefined) return
        this.parent.removeChild(this)
    }

    changeStyle(newStyle: Partial<PIXI.TextStyle>, cache: boolean = true) {
        this.resetCache(() => super.style = {...super.style, ...newStyle}, cache)
    }

    repositionY(centerY: boolean) {
        if(centerY) {
            this.y = this.initialY + (this.initialH - this.height) / 2
        } else {
            this.y = this.initialY
        }
    }

    centerX() {
        this.x = this.initialX + (this.initialW - this.width) / 2
    }

    disableTip() {
        uiGameManager.toolTipController.disableTip(this)
    }

    setTip(title: TranslationObject, bodyParagraphs: TranslationObject[]) {
        const toolTipText: ToolTipText = () => ({title: title, body: bodyParagraphs})
        uiGameManager.toolTipController.createTip(toolTipText, this)
    }

    private initClick() {
        this.on('click', (event) => {
            this.clickAction(event)
        })
        this.on('tap', (event) => {
            this.clickAction(event)
        })
    }

    setClickAction(action: (event) => void) {
        this.interactive = true
        this.cursor = 'pointer'
        this.clickAction = action
    }

    removeClickAction() {
        this.interactive = false
        this.cursor = 'auto'
    }

    centerXInParent() {
        if(this.parent == undefined) return
        this.x = this.parent.width / 2 - this.width / 2
    }

    centerYInParent() {
        if(this.parent == undefined) return
        this.y = this.parent.height / 2 - this.height / 2
    }

    makeBold(cache: boolean = true) {
        this.changeStyle({
            fontWeight: GameFont.Weight.Bold,
        }, cache)
    }

    makeSemiBold(cache: boolean = true) {
        this.changeStyle({
            fontWeight: GameFont.Weight.SemiBold,
        }, cache)
    }

    removeBold(cache: boolean = true) {
        this.changeStyle({
            fontWeight: GameFont.Weight.Normal,
        }, cache)
    }

    resetCache(callback: () => void, cache: boolean = true) {
        if(cache == false) {
            callback()
            return
        }

        this.cacheAsBitmap = false
        callback()
        this.cacheAsBitmap = true
    }
}
